/** A trimmed form value, or undefined when it is blank, so blank fields are left out of a request. */
export const trimmedOrUndefined = (value: string): string | undefined => value.trim() || undefined;

/** The decoded value, or the value as it is when it is not valid URI encoding. */
export const safeDecodeURIComponent = (value: string): string => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};
